module.exports = __webpack_public_path__ + "img/logo-active-bg-sprite.e2873d65.png";